// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-50720ebf]{display:flex}.align-items-center[data-v-50720ebf]{align-items:center}#time-traveller-previous[data-v-50720ebf]{color:#327ab8}", ""]);
// Exports
module.exports = exports;
